import React, { PureComponent } from 'react'
import { Panel, Row, Button } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import InputCheckbox from '../../../commons/form/InputCheckBox'
import SimpleTablePage from '../../../../containers/commons/general/SimpleTablePage'
import InputSelect from '../../../../components/commons/form/InputSelect'
import { compareValues } from '../../../../util/utils'
import { operationTabs } from '../../../../constants/management/operations'
import { permissions } from '../../../../constants/backendIds'
import { fleetsTab } from '../../../../constants/management/fleets'
import { Link } from 'react-router-dom'
import AddDossiersToFleetModalPage from '../../../../containers/management/fleets/auxModals/AddDossiersToFleetModalPage'
import ChargeDossiersModalPage from '../../../../containers/management/fleets/auxModals/ChargeDossiersModalPage'
import { validateDistinctStage } from '../../../../util/management/fleetsUtils'
import * as fleetsUtils from '../../../../util/management/fleetsUtils'
import { dossierSubTypeId } from '../../../../constants/dossier/common/dossierSubType'

class DossiersListFleetDetailsComponent extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      openDossierPanel: false,
      dossiersLoaded: false,
      filters: {
        orderBy: '+number',
        selectedCheck_massive: false
      }
    }
  }

  componentDidMount () {
    if (this.props.fleet && !this.props.create && this.state.openDossierPanel) {
      this.props.actions.getDossierDetailsFleet(this.props.fleet.fleetId)
      this.setState({ dossiersLoaded: true })
      if (this.props.dataActions.length === 0 || this.props.operationActions.length === 0) {
        this.props.actions.getFleetOperations()
      }
    }
  }

  collapsePanelDossier () {
    this.setState({ openDossierPanel: !this.state.openDossierPanel })
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.fleet && !this.props.create && ((this.props.tabActiveKey !== prevProps.tabActiveKey && this.props.tabActiveKey === fleetsTab.FLEETS_DOSSIERS && this.state.openDossierPanel) || (this.props.tabActiveKey === fleetsTab.FLEETS_DOSSIERS && this.state.openDossierPanel && this.state.openDossierPanel !== prevState.openDossierPanel))) {
      this.props.actions.getDossierDetailsFleet(this.props.fleet.fleetId)
      this.setState({ dossiersLoaded: true, selectedCheck_massive: false })
      if (this.props.dataActions.length === 0 || this.props.operationActions.length === 0) {
        this.props.actions.getFleetOperations()
      }
    }
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.changeCheckAll !== prevProps.changeCheckAll) {
      this.setState({ selectedCheck_massive: false })
    }
    return null
  }

  getIconClass (field) {
    if (this.state.filters.orderBy.includes(field)) {
      return this.state.filters.orderBy.includes('-') ? 'ico-sort-selected-asc' : 'ico-sort-selected-desc'
    } else {
      return 'ico-sort'
    }
  }

  onOrderChange (e) {
    const newOrderBy = this.state.filters.orderBy.includes(`+${e.currentTarget.dataset.field}`) ? `-${e.currentTarget.dataset.field}` : `+${e.currentTarget.dataset.field}`
    this.setState({ filters: { orderBy: newOrderBy } })
    this.order(e.currentTarget.dataset.field, newOrderBy.includes('+') ? 'asc' : 'desc')
  }

  order (field, order) {
    let dossiers = JSON.parse(JSON.stringify(this.props.dossierFleetDetails))
    dossiers = dossiers.sort(compareValues(field, order))
    this.props.actions.getDossierDetailsFleetSuccess(dossiers)
  }

  onCheckAll (e) {
    this.setState({ selectedCheck_massive: e })
    let dossiers = JSON.parse(JSON.stringify(this.props.dossierFleetDetails))

    dossiers.map(dossier => {
      dossier.checked = e
    })

    this.props.actions.getDossierDetailsFleetSuccess(dossiers)
    this.props.documentsAllSelected(e)
  }

  onCheckOne (e, id) {
    let dossiers = JSON.parse(JSON.stringify(this.props.dossierFleetDetails))

    dossiers.map(dossier => {
      if (dossier.dossierId === id) {
        dossier.checked = e
      }
    })

    this.props.actions.getDossierDetailsFleetSuccess(dossiers)

    if (dossiers.filter(dossier => dossier.checked).length === dossiers.length) {
      this.props.documentsAllSelected(true)
      this.setState({ selectedCheck_massive: true })
    } else {
      this.props.documentsAllSelected(false)
      this.setState({ selectedCheck_massive: false })
    }
  }

  refresh () {
    this.props.actions.getDossierDetailsFleet(this.props.fleet.fleetId)
    this.setState({ selectedCheck_massive: false })
  }

  select () {
    let changeCheckAll = this.state.changeCheckAll
    this.setState({ changeCheckAll: !changeCheckAll })
    this.props.actions.getDossierDetailsFleet(this.props.fleet.fleetId)
    this.props.actions.openAddDossiersToFleetModal(this.props.fleet)
  }

  charge () {
    this.props.actions.fetchPaymentCombo(false)
    this.props.actions.fetchVehicleType()

    let changeCheckAll = this.state.changeCheckAll
    this.setState({ changeCheckAll: !changeCheckAll })
    this.props.actions.openChargeDossiersModal(this.props.fleet)
  }

  delete () {
    let selectedDossiers = this.props.dossierFleetDetails.filter(dossier => dossier.checked)
    if (this.validateDelete(selectedDossiers)) {
      this.props.actions.openModal('deleteDossierFromFleet', () => { this.deleteOK(selectedDossiers, this.props.fleet.fleetId) }, null, null, null, [{ id: '##FLEET_CODE##', value: this.props.fleet.fleetCode }, { id: '##NUMDOSSIERS##', value: selectedDossiers.length }], null)
    }
  }

  validateDelete (selectedDossiers) {
    var noDelete = selectedDossiers.filter(dossier => dossier.hasFleetCharges)

    if (noDelete && noDelete.length > 0) {
      this.props.actions.openModal('noDeleteDossierFromFleetForCharges', null, null, null, null, [{ id: '##DOSSIER_NUMBER##', value: noDelete.map(dossier => dossier.number) }], null)

      return false
    }
    return true
  }

  deleteOK (dossiers, fleet) {
    let changeCheckAll = this.state.changeCheckAll
    this.setState({ changeCheckAll: !changeCheckAll })
    let dossiersIds = dossiers.map(dossier => dossier.dossierId)

    new Promise((resolve) => {
      this.props.actions.deleteDossiersFromFleet(dossiersIds, fleet, resolve)
    }).then(() => {
      this.props.actions.getDossierDetailsFleet(this.props.fleet.fleetId)
    })
  }

  openConditionsFleetComponent (selectedDossiers) {
    if (validateDistinctStage(selectedDossiers)) {
      this.props.actions.openModal('notDistinctStage')
    } else {
      this.props.openConditionsFleetComponent(selectedDossiers)
    }
  }

  render () {
    const {
      t,
      dossierFleetDetails,
      readOnlyFields,
      dataActions,
      operationActions
    } = this.props
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    const numDossiers = !this.state.dossiersLoaded ? '' : (dossierFleetDetails ? dossierFleetDetails.length : 0)
    const selectedDossiers = this.props.dossierFleetDetails.filter(dossier => dossier.checked)
    let bar = !this.state.dossiersLoaded ? '' : ' | '
    let columnsTable = [
      <th key={0} data-field="number" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}DOSSIER_NUMBER`)}&nbsp;<i className={this.getIconClass('number')}></i>
      </th>,
      <th key={1} data-field="organizedUnit" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}ORGANIZED_UNIT`)}&nbsp;<i className={this.getIconClass('organizedUnit')}></i>
      </th>,
      <th key={2} data-field="clientName" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}CLIENT`)}&nbsp;<i className={this.getIconClass('clientName')}/>
      </th>,
      <th key={3} data-field="finalClientName" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}FINAL_CLIENT`)}&nbsp;<i className={this.getIconClass('finalClientName')}/>
      </th>,
      <th key={4} data-field="vehicle" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}VEHICLE`)}&nbsp;<i className={this.getIconClass('vehicle')}/>
      </th>,
      <th key={5} data-field="model" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}MODEL`)}&nbsp;<i className={this.getIconClass('model')}></i>
      </th>,
      <th key={6} data-field="salesMan" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}SALESMAN`)}&nbsp;<i className={this.getIconClass('salesMan')}/>
      </th>,
      <th key={7} data-field="stage" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}STAGE`)}&nbsp;<i className={this.getIconClass('stage')}/>
      </th>
    ]
    if (!readOnlyFields) {
      columnsTable.push(
        <th key={8} data-field="checked" className='flet-detail-dossier-check-title' >
          <Field
            component={InputCheckbox}
            name={'selectedCheck_massive'}
            onChange={(event) => this.onCheckAll(event)}
            checked={this.state.selectedCheck_massive}
          />
        </th>
      )
    }

    return (
      <>
        <AddDossiersToFleetModalPage></AddDossiersToFleetModalPage>
        <ChargeDossiersModalPage fieldsConfiguration={this.props.fieldsConfiguration}> </ChargeDossiersModalPage>
        <div id="dossiersListFleetDetailsComponent">
          {!readOnlyFields &&
            <div className="_nf dossier-panel" >
              <Row className='flexInLine al-R marg-bottom-15'>
                <Button
                  id="fleet-dossier-details-select-button"
                  className="_Btn accept stk long300"
                  onClick = {() => this.select()}
                  disabled={selectedDossiers.length > 0}>
                  <i className='iDocIcon-folder-open-solid'></i>
                  {t(`${tKey}AUX_MODALS.CHARGE`)}
                </Button>
                <Button
                  id="fleet-dossier-details-charge-button"
                  className="_Btn accept"
                  onClick = {() => this.charge()}
                  disabled={selectedDossiers.length > 0}>
                  <i className='iDocIcon-file-excel'></i>{t(`${tKey}AUX_MODALS.SELECT`)}
                </Button>
                <Button
                  id="fleet-dossier-details-delete-button"
                  className="_Btn cancel"
                  onClick = {() => this.delete()}
                  disabled={selectedDossiers.length === 0}>
                  {t(`${tKey}DELETE`)}
                </Button>
              </Row>
            </div>
          }
          <div className="_nf dossier-panel" >
            <div className="header-panel  fleet-panel-box" onClick={() => this.collapsePanelDossier()}>

              <div className="name-wrapper fleet-panel-box-title">
                <h4>{t(`${tKey}DOSSIERS`)} {bar} <span className='fleet-panel-subTitle'>{numDossiers}</span> </h4>
              </div>

              <i className={this.state.openDossierPanel ? 'ico-arrow-black-down fleet-panel-box-caret' : 'ico-arrow-black-up fleet-panel-box-caret'} />

            </div>
            <Panel expanded={this.state.openDossierPanel} onToggle={() => {}}>
              <Panel.Collapse>
                <div id="fleet-dossier-details-table">
                  <div className='flexInLine al-R'>
                    {(this.props.fleet && !this.props.create && this.props.tabActiveKey === fleetsTab.FLEETS_DOSSIERS && this.state.openDossierPanel) &&
                      <Button
                        id="fleet-dossier-details-refresh-button"
                        className="_Btn accept stk"
                        onClick = {() => this.refresh()}>
                        <i className='iDocIcon-update'></i>
                        {t(`${tKey}AUX_MODALS.REFRESH`)}
                      </Button>
                    }
                  </div>
                  <SimpleTablePage
                    columns={columnsTable}
                    rows={dossierFleetDetails && dossierFleetDetails.map((row, idx) => (
                      <tr key={idx}>
                        <td>
                          {
                            row.urlToNavigate ? (
                              <Link to={`/dossier${row.urlToNavigate}`}>
                                {row.number}
                              </Link>
                            ) : row.number
                          }
                        </td>
                        <td>{row.organizedUnit}</td>
                        <td>{row.clientName}</td>
                        <td>{row.finalClientName}</td>
                        <td>{row.vehicle}</td>
                        <td>{row.model}</td>
                        <td>{row.salesMan}</td>
                        <td>{row.stage}</td>
                        {!readOnlyFields && <td>{<Field
                          component={InputCheckbox}
                          name={'selectedCheck_' + row.dossierId}
                          id={'selectedCheck_' + row.dossierId}
                          checked={row.checked ? row.checked : false}
                          onChange={(event) => this.onCheckOne(event, row.dossierId)}
                        />}
                        </td>}
                      </tr>
                    ))}
                  ></SimpleTablePage>
                  {!readOnlyFields &&
                    <div className='actionsLine'>
                      <Field
                        component={InputSelect}
                        colWidth={0} // 25, 33, 50, 75, 100 default=25
                        id="dossierListFleet_dataId"
                        name='dataId'
                        placeholder={t(`${tKey}DATA`)}
                        controlLabel={t(`${tKey}DATA`)}
                        options={dataActions}
                        valueKey="managementActionId"
                        labelKey="name"
                        disabled={selectedDossiers.length === 0}
                        onInputChange={(val) => { document.activeElement?.blur(); this.props.launchAction(val, operationTabs.DATA); this.props.change('dataId', null) }}
                      />
                      <Field
                        component={InputSelect}
                        colWidth={0} // 25, 33, 50, 75, 100 default=25
                        id="dossierListFleet_actionId"
                        name='actionId'
                        placeholder={t(`${tKey}ACTIONS`)}
                        controlLabel={t(`${tKey}ACTIONS`)}
                        options={fleetsUtils.getSaleOperateActions(operationActions, (this.props.fleet?.dossierSubType === dossierSubTypeId.venta_vn ? dossierSubTypeId.venta_vn : dossierSubTypeId.venta_vo))}
                        valueKey="managementActionId"
                        labelKey="name"
                        disabled={selectedDossiers.length === 0}
                        onInputChange={(val) => { this.props.launchAction(val, operationTabs.OPERATIONS); this.props.change('actionId', null) }}
                      />
                      <Button
                        id="dossierListFleet_btn_conditions"
                        className="_Btn accept stk"
                        onClick={() => this.openConditionsFleetComponent(selectedDossiers)}
                        disabled={selectedDossiers.length === 0}>
                        {t(`${tKey}CONDITIONS`)}
                      </Button>
                      {this.props.fieldsConfiguration && this.props.fieldsConfiguration.documentsFleet && this.props.fieldsConfiguration.documentsFleet.permission === permissions.editable && (
                        <Button
                          id="dossierListFleet_btn_documents"
                          className="_Btn accept"
                          onClick={() => this.props.openDocumentsModal(this.props.fleet, selectedDossiers)}
                          disabled={selectedDossiers.length === 0}>
                          {t(`${tKey}DOCUMENTS`)}
                        </Button>)}
                      {this.props.fieldsConfiguration && this.props.fieldsConfiguration.economicFleet && this.props.fieldsConfiguration.economicFleet.permission && this.props.fieldsConfiguration.economicFleet.permission === permissions.editable && (
                        <Button
                          id="dossierListFleet_btn_financial_analysis"
                          className="_Btn accept"
                          onClick={() => this.props.openEconomicPlan(this.props.fleet, selectedDossiers)}
                          disabled={selectedDossiers.length === 0}>
                          {t(`${tKey}FINANCIAL_ANALYSIS`)}
                        </Button>)}
                    </div>
                  }
                </div>
              </Panel.Collapse>
            </Panel>
          </div>
        </div>
      </>
    )
  }
}

export default reduxForm({
  form: 'DossiersListFleetDetailsComponent'
})(DossiersListFleetDetailsComponent)
